import React, { Fragment } from 'react';
import DaywiseReportView from './DaywiseReportView';

// Thin route entry — the V3 shell lives inside the view.
const DaywiseReport = () => (
    <Fragment>
        <DaywiseReportView />
    </Fragment>
);

export default DaywiseReport;
